import { Grid } from "../../../imports/muiImport";
import { useSelector } from "../../../imports/generalImport";
import UserDetailPayment from './paymentUtils/UserDetailPayment';
import UserPayButton from './paymentUtils/UserPayButton';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import PaymentOrderReceipt from "./paymentUtils/PaymentOrderReceipt";

function Payment() {
  const { isLoggedIn } = useAuth();

  return (
    <Grid container
      maxWidth="false"
      sx={{
        py: { xs: 1, sm: 3, lg: 2 },
        px: { xs: 2, sm: 2, lg: 2 },
        minWidth: "100%",
        alignContent: {
          lg: "flex-start"
        },
        border: 1,
        borderRadius: {
          xs: 2,
          lg: 3,
        },
        borderColor: "lightSecondary.main",
        boxShadow: { xs: 0, sm: 5, lg: 1 },
      }}>
      <Grid item xs={12} lg={isLoggedIn ? 5 : 12} xl={isLoggedIn ? 6 : 12} sx={{ pr: { lg: 1 } }} >
        <PaymentOrderReceipt />
      </Grid>

      {isLoggedIn &&
        <>
          {/* Receiver Details */}
          <Grid item xs={12} lg={isLoggedIn ? 7 : 12} xl={isLoggedIn ? 6 : 12}>
            <UserDetailPayment />
          </Grid>
        </>
      }

      {/* User Pay Button */}
      <Grid item xs={12}
        sx={{
          position: { xs: "sticky", lg: "relative" },
          bottom: 0,
          zIndex: 0,
        }}
      >
        <UserPayButton />
      </Grid>
    </Grid>
  );

}


export default Payment
